import { render, staticRenderFns } from "./EchartsPieChart.vue?vue&type=template&id=7ce4fe15&scoped=true"
import script from "./EchartsPieChart.vue?vue&type=script&lang=js"
export * from "./EchartsPieChart.vue?vue&type=script&lang=js"
import style0 from "./EchartsPieChart.vue?vue&type=style&index=0&id=7ce4fe15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce4fe15",
  null
  
)

export default component.exports